<template>
  <div v-if="notifications.showing">
    <notifications />
  </div>
</template>

<script>
import MyToastComponent from "../Notifications/NotificationComponent";
export default {
  name: "Notifications",
  computed: {
    notifications() {
      let notification = this.$store.state.notifications;
      const content = {
        component: MyToastComponent,
        props: {
          notifications: notification,
        },
      };
      if (notification.showing) {
        console.log("call cotification component");
        this.$toast[notification.type](content, {
          position: notification.position
            ? notification.position
            : "top-center",
          timeout: notification.timeout ? notification.timeout : 3000,
          closeOnClick: notification.closeOnClick,
          pauseOnFocusLoss: notification.pauseOnFocusLoss,
          pauseOnHover: notification.pauseOnHover,
          draggable: notification.draggable,
          draggablePercent: notification.draggablePercent,
          showCloseButtonOnHover: notification.showCloseButtonOnHover,
          hideProgressBar: notification.hideProgressBar,
          closeButton: notification.closeButton,
          icon: notification.icon,
          rtl: notification.rtl,
        });
        notification.showing = false;
      }
      return notification;
    },
  },
};
</script>
